import React from "react";
var EachFilter = function (props) {
    var _a;
    return (React.createElement("div", { id: "filter-show-hide", className: "filterasset-drop-body" },
        React.createElement("ul", { className: "bodylist me-3", id: "asset" },
            React.createElement("div", { className: "d-flex mb-2 " }), (_a = props === null || props === void 0 ? void 0 : props.singleFilter.subList) === null || _a === void 0 ? void 0 :
            _a.map(function (subFilter, idx) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { key: idx },
                        React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom " },
                            React.createElement("input", { type: "checkbox", onChange: function (e) {
                                    props.onChange(props.singleFilter.id, subFilter.id, e.target.checked);
                                }, name: subFilter.name, value: subFilter.id, checked: subFilter.checked }),
                            React.createElement("label", { className: "bodylist-title DMSan_14_500 txt_primaryGrey" }, subFilter.name)))));
            }))));
};
export default EachFilter;
